import { useState } from 'react';
import { PDPModal, UnauthenticatedRDPModal } from '@hungryroot/rdp';
import PairingCard from '../../generic/PairingCard';

interface PairingCardProps {
  data: { id: number };
}

const RecipePairingCard = ({ data }: PairingCardProps) => {
  const [rpdOpen, setRpdOpen] = useState(false);
  const [openPDPId, setOpenPDPId] = useState<number | null>(null);
  return (
    <div className="cpairing-card">
      <PairingCard
        testid="cpairing-card"
        pairingId={data.id}
        pairingData={data}
        cardType={3}
        onClick={() => setRpdOpen(true)}
        isRecipesPage={true}
      />
      {openPDPId !== null && (
        <PDPModal
          stacked={true}
          id={openPDPId}
          onDismiss={() => {
            setOpenPDPId(null);
            setRpdOpen(false);
          }}
          excludeIcons={['favorite']}
          onBackClick={() => setOpenPDPId(null)}
          excludeCredits={true}
        />
      )}
      {rpdOpen && (
        <UnauthenticatedRDPModal
          id={data.id}
          onProductClick={(productId) => setOpenPDPId(productId)}
          onDismiss={() => setRpdOpen(false)}
        />
      )}
    </div>
  );
};

export default RecipePairingCard;
